import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { AnyEmptyQuestion } from '../../../../types';
import DraggableQuestion from '../../QuestionViewerEditor/QuestionContainer/DraggableQuestionContainer';

interface DraggableQuestionViewerContainerProps {
  question: AnyEmptyQuestion;
  index: number;
}

function DraggableQuestionContainer({ question, index }: DraggableQuestionViewerContainerProps) {
  return (
    <Draggable draggableId={question._id} index={index}>
      {(draggableProvided, draggableSnapshot) => (
        <DraggableQuestion
          index={index}
          snapshot={draggableSnapshot}
          provided={draggableProvided}
          question={question}
        />
      )}
    </Draggable>
  );
}

export default DraggableQuestionContainer;
